import { Div } from '@vgrubs/components';
import { ModifierItemV2Response } from 'components/src/types/menu.types';
import { SortableList } from '../../components/SortableList';
import { DraftModifierOption } from '../../helpers/modifierOptionsOrder';
import { ModifierBoxComponent } from './ModifierComponents';

/**
 * The options of the Edit Modifier Group popup, sortable by their handle. The
 * new order stays in the popup until it is confirmed.
 */
export const SortableModifierOptions = ({
  options,
  onReorder,
  hiddenIndex,
  sortable,
  onRemove,
  onEdit,
}: {
  options: DraftModifierOption[];
  onReorder: (options: DraftModifierOption[]) => void;
  /** The option being edited in the form above, left out of the list. */
  hiddenIndex: number | null;
  sortable: boolean;
  onRemove: (index: number) => void;
  onEdit: (option: ModifierItemV2Response, index: number) => void;
}) => (
  <Div $flex $column $gap="8px">
    <SortableList
      items={options}
      getId={(o) => o.draftKey}
      getLabel={(o) => o.name}
      onReorder={onReorder}
      disabled={!sortable}
      renderItem={(option, i, dragHandle) =>
        i === hiddenIndex ? null : (
          <ModifierBoxComponent
            option={option}
            i={i}
            handleRemoveOption={onRemove}
            handleEditOption={onEdit}
            dragHandle={dragHandle}
          />
        )
      }
    />
  </Div>
);
